import { useEffect, useState } from "react";
import { Phone, Instagram } from "lucide-react";

export default function FloatingCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="floating-cta"
      className={`fixed z-40 left-1/2 -translate-x-1/2 bottom-5 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <div className="flex items-center gap-1 bg-[#FAEDE6]/85 backdrop-blur-xl border border-[#B78782]/40 rounded-full shadow-[0_8px_30px_rgba(74,55,55,0.12)] px-1.5 py-1.5">
        <a
          href="tel:+64211097531"
          data-testid="floating-call-btn"
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#B78782] text-[#FAEDE6] text-[11px] tracking-[0.24em] uppercase hover:bg-[#C5A8A4] transition-colors duration-300"
        >
          <Phone size={14} strokeWidth={1.75} />
          <span className="hidden sm:inline">Call Amber</span>
          <span className="sm:hidden">Call</span>
        </a>
        <a
          href="https://www.instagram.com/ambers_mobilebeauty"
          target="_blank"
          rel="noreferrer"
          data-testid="floating-instagram-btn"
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-[#4A3737] text-[11px] tracking-[0.24em] uppercase hover:bg-[#B78782]/10 transition-colors duration-300"
        >
          <Instagram size={14} strokeWidth={1.75} />
          <span className="hidden sm:inline">Instagram</span>
          <span className="sm:hidden">DM</span>
        </a>
      </div>
    </div>
  );
}
